import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-6 md:py-8">
        {/* 네비게이션 링크 - 상단으로 이동 */}
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mb-4 md:mb-5 text-xs">
          <Link to="/" className="text-white/70 hover:text-gold transition-colors cursor-pointer">홈</Link>
          <span className="text-white/30">|</span>
          <Link to="/about" className="text-white/70 hover:text-gold transition-colors cursor-pointer">회사소개</Link>
          <span className="text-white/30">|</span>
          <Link to="/business" className="text-white/70 hover:text-gold transition-colors cursor-pointer">사업영역</Link>
          <span className="text-white/30">|</span>
          <Link to="/portfolio" className="text-white/70 hover:text-gold transition-colors cursor-pointer">포트폴리오</Link>
        </div>

        {/* 회사 정보 */}
        <div className="mb-4 md:mb-5">
          <div className="flex flex-col md:flex-row md:flex-wrap items-start md:items-center md:justify-center gap-x-3 md:gap-x-4 gap-y-1 text-white/60 text-xs">
            <span className="flex items-center gap-1.5">
              <span className="text-gold">회사명</span>
              <span>GB더플래닛</span>
            </span>
            <span className="hidden md:inline text-white/30">|</span>
            <span className="flex items-center gap-1.5">
              <span className="text-gold">대표자</span>
              <span>이동준</span>
            </span>
            <span className="hidden md:inline text-white/30">|</span>
            <span className="flex items-center gap-1.5">
              <span className="text-gold">주소</span>
              <span>서울특별시 구로구 경인로 40길 25, 3층(청실상가)</span>
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:flex-wrap items-start md:items-center md:justify-center gap-x-3 md:gap-x-4 gap-y-1 text-white/60 text-xs mt-1.5">
            <span className="flex items-center gap-1.5">
              <span className="text-gold">사업분야</span>
              <span>부동산개발·시행, 업무대행, 분양·광고대행</span>
            </span>
          </div>
        </div>

        {/* 연락처 및 등록번호 */}
        <div className="mb-4 md:mb-5">
          <div className="flex flex-col md:flex-row md:flex-wrap items-start md:items-center md:justify-center gap-x-3 md:gap-x-4 gap-y-1 text-white/60 text-xs">
            <span className="flex items-center gap-1.5">
              <span className="text-gold">TEL</span>
              <span>02-2681-7772</span>
            </span>
            <span className="hidden md:inline text-white/30">|</span>
            <span className="flex items-center gap-1.5">
              <span className="text-gold">FAX</span>
              <span>02-2681-7773</span>
            </span>
            <span className="hidden md:inline text-white/30">|</span>
            <span className="flex items-center gap-1.5">
              <span className="text-gold">법인등록번호</span>
              <span>110111-0930022</span>
            </span>
            <span className="hidden md:inline text-white/30">|</span>
            <span className="flex items-center gap-1.5">
              <span className="text-gold">사업자등록번호</span>
              <span>718-87-03792</span>
            </span>
          </div>
        </div>

        {/* 하단: 저작권 */}
        <div className="pt-3 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-center gap-1.5 md:gap-3">
            <span className="text-white/30 text-xs">
              © 2025 지비더플래닛. All rights reserved.
            </span>
            <span className="hidden md:inline text-white/30">|</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="text-white/30 hover:text-white/50 text-xs transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
